/**
 * Error thrown when a merchant integration error occurs.
 */
export class MerchantRejectedClickError extends Error {
  constructor({message}: {message?: string}) {
    super(message);
    this.name = 'MerchantRejectedClickError';
    Object.setPrototypeOf(this, MerchantRejectedClickError.prototype);
  }
}
